/*
 * Shared LP add-to-cart helper.
 * Mirrors the theme's product-form.js flow exactly: each item is posted as
 * FormData (same as the product form's native submit body) with `sections`
 * and `sections_url` appended, which returns the single-item response shape
 * { id, quantity, ..., sections }. The last response is handed verbatim to
 * cart-drawer.handleAddedItem — same object the theme passes — so the
 * rendered `cart-drawer` section stays consistent with the cart lines the
 * change/remove handlers index into.
 */
window.lpaCartAdd = function (items) {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.handleAddedItem !== 'function') {
    window.location.href = '/cart';
    return Promise.resolve(null);
  }
  if (typeof drawer.setActiveElement === 'function') {
    drawer.setActiveElement(document.activeElement);
  }

  function addOne(item) {
    var formData = new FormData();
    formData.append('id', item.id);
    formData.append('quantity', item.quantity || 1);
    if (item.selling_plan) {
      formData.append('selling_plan', item.selling_plan);
    }
    formData.append(
      'sections',
      drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',')
    );
    formData.append('sections_url', window.location.pathname);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (res) { return res.json(); });
  }

  var chain = Promise.resolve();
  var last;
  items.forEach(function (item) {
    chain = chain.then(function () {
      return addOne(item).then(function (resp) { last = resp; });
    });
  });

  return chain
    .then(function () {
      if (last && last.id) {
        drawer.handleAddedItem(last);
        return last;
      }
      window.location.href = '/cart';
      return null;
    })
    .catch(function () {
      window.location.href = '/cart';
      return null;
    });
};
